module.exports = __webpack_public_path__ + "static/media/bagwhiteicon.4c0037e5.svg";